const setupStatusList = [
    {
        value: 1,
        name:'已开启'
    },
    {
        value: 0,
        name:'已关闭'
    },
]
export default setupStatusList